document.querySelectorAll('.scroller').forEach(scroller => {
	const images = [...scroller.querySelectorAll('.images img')]
	const headlines = [...scroller.querySelectorAll('.text h1, .text h2, .text h3')].slice(Math.max(0, scroller.querySelectorAll('.text h1, .text h2, .text h3').length - images.length))
	const imagebox = scroller.querySelector('.images')
	let active = 0

	if (!images.length || !headlines.length || !imagebox) return

	const setActive = index => images.forEach((image, i) => image.classList.toggle('active', i === (active = index)))
	const update = () => {
		let edge = imagebox.getBoundingClientRect().bottom - imagebox.offsetHeight * 0.1
		let index = headlines.findLastIndex(headline => headline.getBoundingClientRect().top < edge)
		if (index >= 0 && index !== active) setActive(index)
	}

	setActive(0)
	update()
	const observer = new IntersectionObserver(update, {
		root: null,
		threshold: 0,
		rootMargin: '0px 0px -10% 0px'
	})
	headlines.forEach(headline => observer.observe(headline))
})
